import axios from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { AccountOutputDTO } from 'src/services/payment/account/accountDTO'
import { IsAuthorized } from 'src/authentication/IsAuthorized'
class AccountServices {
  async getCreditsByBusinessUnitId(hash: string, currency_hash: string): Promise<AccountOutputDTO[]> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_PAYMENT}/account/credit/hash/${hash}/currency/${currency_hash}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
  async getTotalCreditsByBusinessUnitHash(business_unit_hash: string): Promise<AccountOutputDTO[]> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_PAYMENT}/account/total-credit/${business_unit_hash}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getTotalBalancesAgainstByBusinessUnitHash(business_unit_hash: string): Promise<AccountOutputDTO[]> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_PAYMENT}/account/total-debt/${business_unit_hash}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async updateCreditPendingAmount(id:number, body:any): Promise<any[]> {
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_URL_PAYMENT}/account/${id}`
        ,body,
        {
          headers: { 
            'authentication-token': getJWT()!
          },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getReceivedAccountTransfer(hash_reservation:string): Promise<any[]> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_PAYMENT}/account-transfer/to/hash-reservation/${hash_reservation}`
        ,
        {
          headers: { 
            'authentication-token': getJWT()!
          },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getSentAccountTransfer(hash_reservation:string): Promise<any[]> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_PAYMENT}/account-transfer/from/hash-reservation/${hash_reservation}`
        ,
        {
          headers: { 
            'authentication-token': getJWT()!
          },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}
export const accountServices = new AccountServices()
